import { SuppliesActionTypes } from './supplies.types'
import { API_CONSTANTS } from '../../utils/AppConstants'

const INITIAL_STATE = {
    addSuppliesCategorySuccess: null,
    addSuppliesCategoryError: null,
    addSuppliesCategoryReqStatus: '',
    suppliesCategoryListSuccess: null,
    suppliesCategoryListError: null,
    updateSuppliesCategoryDetailSuccess: null,
    updateSuppliesCategoryDetailError: null,
    updateSuppliesCategoryDetailReqStatus: '',
    addSuppliesItemSuccess: null,
    addSuppliesItemError: null,
    addSuppliesItemReqStatus: '',
    suppliesItemListSuccess: null,
    suppliesItemListError: null,
    suppliesItemDetailSuccess: null,
    suppliesItemDetailError: null,
    consumeSuppliesItemSuccess: null,
    consumeSuppliesItemError: null,
    consumeSuppliesItemReqStatus: '',
    updateSuppliesItemStockSuccess: null,
    updateSuppliesItemStockError: null,
    updateSuppliesItemStockReqStatus: ''
}

const suppliesReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SuppliesActionTypes.ADD_SUPPLIES_CATEGORY_REQUEST_SUCCESS:
            return {
                ...state,
                addSuppliesCategorySuccess: action.payload,
                addSuppliesCategoryError: null,
                addSuppliesCategoryReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case SuppliesActionTypes.ADD_SUPPLIES_CATEGORY_REQUEST_ERROR:
            return {
                ...state,
                addSuppliesCategorySuccess: null,
                addSuppliesCategoryError: action.payload,
                addSuppliesCategoryReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case SuppliesActionTypes.ADD_SUPPLIES_CATEGORY_REQUEST_STATUS:
            return {
                ...state,
                addSuppliesCategoryReqStatus: ''
            }
        case SuppliesActionTypes.SUPPLIES_CATEGORY_LIST_REQUEST_SUCCESS:
            return {
                ...state,
                suppliesCategoryListSuccess: action.payload,
                suppliesCategoryListError: null
            }
        case SuppliesActionTypes.SUPPLIES_CATEGORY_LIST_REQUEST_ERROR:
            return {
                ...state,
                suppliesCategoryListSuccess: null,
                suppliesCategoryListError: action.payload
            }
        case SuppliesActionTypes.UPDATE_SUPPLIES_CATEGORY_DETAIL_REQUEST_SUCCESS:
            return {
                ...state,
                updateSuppliesCategoryDetailSuccess: action.payload,
                updateSuppliesCategoryDetailError: null,
                updateSuppliesCategoryDetailReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case SuppliesActionTypes.UPDATE_SUPPLIES_CATEGORY_DETAIL_REQUEST_ERROR:
            return {
                ...state,
                updateSuppliesCategoryDetailSuccess: null,
                updateSuppliesCategoryDetailError: action.payload,
                updateSuppliesCategoryDetailReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case SuppliesActionTypes.UPDATE_SUPPLIES_CATEGORY_DETAIL_REQUEST_STATUS:
            return {
                ...state,
                updateSuppliesCategoryDetailReqStatus: ''
            }
        case SuppliesActionTypes.ADD_SUPPLIES_ITEM_REQUEST_SUCCESS:
            return {
                ...state,
                addSuppliesItemSuccess: action.payload,
                addSuppliesItemError: null,
                addSuppliesItemReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case SuppliesActionTypes.ADD_SUPPLIES_ITEM_REQUEST_ERROR:
            return {
                ...state,
                addSuppliesItemSuccess: null,
                addSuppliesItemError: action.payload,
                addSuppliesItemReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case SuppliesActionTypes.ADD_SUPPLIES_ITEM_REQUEST_STATUS:
            return {
                ...state,
                addSuppliesItemReqStatus: ''
            }
        case SuppliesActionTypes.SUPPLIES_ITEM_LIST_REQUEST_SUCCESS:
            return {
                ...state,
                suppliesItemListSuccess: action.payload,
                suppliesItemListError: null
            }
        case SuppliesActionTypes.SUPPLIES_ITEM_LIST_REQUEST_ERROR:
            return {
                ...state,
                suppliesItemListSuccess: null,
                suppliesItemListError: action.payload
            }
        case SuppliesActionTypes.SUPPLIES_ITEM_DETAIL_REQUEST_SUCCESS:
            return {
                ...state,
                suppliesItemDetailSuccess: action.payload,
                suppliesItemDetailError: null
            }
        case SuppliesActionTypes.SUPPLIES_ITEM_DETAIL_REQUEST_ERROR:
            return {
                ...state,
                suppliesItemDetailSuccess: null,
                suppliesItemDetailError: action.payload
            }
        case SuppliesActionTypes.CONSUME_SUPPLIES_ITEM_REQUEST_SUCCESS:
            return {
                ...state,
                consumeSuppliesItemSuccess: action.payload,
                consumeSuppliesItemError: null,
                consumeSuppliesItemReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case SuppliesActionTypes.CONSUME_SUPPLIES_ITEM_REQUEST_ERROR:
            return {
                ...state,
                consumeSuppliesItemSuccess: null,
                consumeSuppliesItemError: action.payload,
                consumeSuppliesItemReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case SuppliesActionTypes.CONSUME_SUPPLIES_ITEM_REQUEST_STATUS:
            return {
                ...state,
                consumeSuppliesItemReqStatus: ''
            }
        case SuppliesActionTypes.UPDATE_SUPPLIES_ITEM_STOCK_REQUEST_SUCCESS:
            return {
                ...state,
                updateSuppliesItemStockSuccess: action.payload,
                updateSuppliesItemStockError: null,
                updateSuppliesItemStockReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case SuppliesActionTypes.UPDATE_SUPPLIES_ITEM_STOCK_REQUEST_ERROR:
            return {
                ...state,
                updateSuppliesItemStockSuccess: null,
                updateSuppliesItemStockError: action.payload,
                updateSuppliesItemStockReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case SuppliesActionTypes.UPDATE_SUPPLIES_ITEM_STOCK_REQUEST_STATUS:
            return {
                ...state,
                updateSuppliesItemStockReqStatus: ''
            }
        case SuppliesActionTypes.LOGOUT:
            return INITIAL_STATE
        default:
            return state
    }
}

export default suppliesReducer